<template lang="pug">
  section.dashboard(v-bind:class="{ overlay: patientsLoading }")
    .overlay-shim
    h1.page-title User Dashboard
    patient-filter(:patientFilters="patientFilters" :applyFilters="applyFilters" :filtersChanged="filtersRemoved")
    patient-filter-tags(:patientFilters="patientFilters" :applyFilters="removeFilters" :hasPatientFilters="hasPatientFilters")
    .patient-list-wrapper
      .patient-entries
        patient-pagination(
          :initialPageSize="dashboardSettings.pageSize"
          :initialPage="dashboardSettings.page"
          :loading="patientsLoading"
          :changePage="applyPageSettings"
          :totalCount="patientCount")
        patient-list(:patients="patients" :loading="patientsLoading" :selectPatient="doSelectPatient" :selectedPatientId="selectedPatientId")
        patient-pagination(
          :initialPageSize="dashboardSettings.pageSize"
          :initialPage="dashboardSettings.page"
          :loading="patientsLoading"
          :changePage="applyPageSettings"
          :totalCount="patientCount")
      .patient-snapshot
        patient-snapshot(
          v-if="!patientsLoading && patients.length > 0"
          :patient="selectedPatient"
          :loading="patientDetailsLoading"
          :markReviewed="markPatientAsReviewed")
</template>

<script>
import PatientList from './patient/PatientList.vue';
import PatientFilter from './patient/PatientFilter.vue';
import PatientFilterTags from './patient/PatientFilterTags.vue';
import PatientPagination from './patient/PatientPagination.vue';
import PatientSnapshot from './patient/PatientSnapshot.vue';
import _ from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    PatientList,
    PatientFilter,
    PatientFilterTags,
    PatientPagination,
    PatientSnapshot
  },
  data() {
    return {
      selectedPatientId: 0,
      filtersRemoved: false
    };
  },
  computed: {
    selectedPatient() {
      return this.getPatientDetailsById(this.selectedPatientId);
    },
    snapshotLoading() {
      return this.patientsLoading || this.patientDetailsLoading;
    },
    ...mapGetters([
      'patients',
      'patientCount',
      'patientsLoading',
      'getPatientDetailsById',
      'patientDetailsLoading',
      'patientSnapshotId',
      'dashboardSettings',
      'patientFilters',
      'hasPatientFilters'
    ])
  },
  methods: {
    doSelectPatient(id) {
      this.selectedPatientId = id;
      this.setPatientSnapshotId(id);
      this.getPatientDetails(id);
    },
    doMarkPatientAsReviewed(patientId) {
      this.markPatientAsReviewed(patientId).then(() => {
        this.getPatientList();
      });
    },
    applyPageSettings(settings) {
      this.setDashboardSettings(settings);
      this.selectedPatientId = 0;
      this.getPatientList();
    },
    applyFilters(filters) {
      this.setPatientFilters(filters);
      this.setDashboardSettings({page: 1});
      this.selectedPatientId = 0;
      if (this.filtersRemoved && !this.hasPatientFilters) {
        this.getPatientList().then(() => {
          this.filtersRemoved = false;
        });
      } else {
        this.delayedRefresh();
      }
    },
    removeFilters(filters) {
      this.setPatientFilters(filters);
      this.filtersRemoved = true;
    },
    delayedRefresh() {
      this.getPatientList().then(() => {
        this.filtersRemoved = false;
      });
    },
    ...mapMutations([
      'setPatientFilters',
      'setPatientSnapshotId',
      'setDashboardSettings'
    ]),
    ...mapActions([
      'getPatientList',
      'getPatientDetails',
      'markPatientAsReviewed'
    ])
  },
  created() {
    this.getPatientList().then(() => {
      // if snapshot was selected previously, use it
      this.selectedPatientId = this.patientSnapshotId;
    });
    // add delay before refreshing
    this.delayedRefresh = _.debounce(this.delayedRefresh, 1000);
  }
};
</script>

<style lang="scss" scoped>
  .overlay-shim {
    display: none;
  }
  .overlay {
    position: relative;
    .overlay-shim {
      display: block;
      content: '';
      @include position(fixed, 0 0 0 0);
      z-index: 9999;
      background: rgba(#fff, 0.5);
    }
  }
  .patient-list-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
  .patient-entries {
    width: 78%;
  }
  .patient-snapshot {
    width: 20%;
    position: relative;
  }
</style>
